/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconBrowser = createReactComponent("outline", "browser", "IconBrowser", [["path", { "d": "M4 4m0 1a1 1 0 0 1 1 -1h14a1 1 0 0 1 1 1v14a1 1 0 0 1 -1 1h-14a1 1 0 0 1 -1 -1z", "key": "svg-0" }], ["path", { "d": "M4 8l16 0", "key": "svg-1" }], ["path", { "d": "M8 4l0 4", "key": "svg-2" }]]);

export { IconBrowser as default };
//# sourceMappingURL=IconBrowser.mjs.map
